import React from 'react';
import { Mail } from 'lucide-react';
import MenuPageShell from '../MenuPageShell';
import InfoCard from '../InfoCard';

const ContactPage = ({ onBack }) => (
  <MenuPageShell title='聯絡我們' icon={Mail} onBack={onBack}>
    <InfoCard head='客戶服務' text={'電郵：support@travel-ec.com\n服務時間：週一至週五 09:00–18:00（香港時間）'}/>
    <InfoCard head='商業合作' text={'廣告投放、旅遊業合作或媒體查詢\n請電郵至：partners@travel-ec.com'}/>
  </MenuPageShell>
);

export default ContactPage;
